import {
  GET_SPOR_TOTO_COUNT_DOWN,
  GET_SPOR_TOTO_COUNT_DOWN_SUCCESS,
  GET_SPOR_TOTO_COUNT_DOWN_FAILURE
} from 'Store/constants';
  
const initialState = {
  data: {},
  isLoading: null,
  error: null
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SPOR_TOTO_COUNT_DOWN:
      return { ...state, data: {}, isLoading: true, error: null };
    case GET_SPOR_TOTO_COUNT_DOWN_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: false };
    case GET_SPOR_TOTO_COUNT_DOWN_FAILURE:
      return { ...state, data: {}, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
  
  